import parseTemplate from "../parseTemplate";
import { isStringTemplatePart } from "../typeGuards";
import { TemplatePart, TemplatePartTypes } from "../types";
import { splitPartsByType } from "../utils/splitPartsByType";
import { extractStatementsWithinParts } from "./extractStatementsWithinParts";
import getRandomStatementExtract from "./getValidRandomStatement";
import replaceStatementWithInput from "./replaceStatementWithInput";

export default function generateScaffoldedParts(
  scope: any,
  markSchemeParts: TemplatePart[]
): TemplatePart[][] {
  const partsByLine = splitPartsByType(
    markSchemeParts,
    TemplatePartTypes.NEWLINE
  );

  return partsByLine
    .map(lineParts => {
      const statementExtracts = extractStatementsWithinParts(lineParts);

      const statementExtract = getRandomStatementExtract(
        scope,
        statementExtracts.filter(it => !it.statementPart.omitFromScaffold)
      );

      const newLineParts = lineParts.reduce<TemplatePart[]>((acc, part) => {
        if (
          statementExtract?.parentPart?.templatePosition ===
          part.templatePosition
        ) {
          const statementPart = statementExtract.statementPart;

          if (part.type === TemplatePartTypes.LATEX) {
            return acc.concat(
              replaceStatementWithInput({
                scope,
                latexPart: part,
                statementPart
              })
            );
          } else if (part.type === TemplatePartTypes.TEXT) {
            const newParts = acc.concat(
              parseTemplate(
                scope,
                part.original.replace(
                  statementPart.original,
                  //https://stackoverflow.com/questions/36441837/bug-in-javascript-string-replace-with-replace-string
                  () => `$${statementPart.original}`
                )
              )
            );
            return newParts;
          }
        }

        return acc.concat(part);
      }, []);

      return filterEmptyStringParts(newLineParts);
    })
    .filter(line => line.length > 0);
}

const filterEmptyStringParts = (parts: TemplatePart[]) =>
  parts.filter(
    part => !isStringTemplatePart(part) || part.value.trim().length !== 0
  );
